import { Typography } from '@/shared/ui';

export const NotFound = () => {
  return (
    <div className="pb-[78px] pt-[46px]">
      <Typography
        className="text-center text-[14px] font-normal leading-5"
        color="text-base-100"
      >
        Nothing was found for your search
      </Typography>
    </div>
  );
};
